"use strict";
/*
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview TODO
 */
(function ($g, createjs, M) {
    var Tween = createjs.Tween;
    var Bitmap = createjs.Bitmap;
    var Container = createjs.Container;

    /**
     * Réduction de la qualité du flou d'arrière plan
     * Diminue la quantité de VRAM nécessaire
     */
    const BG_QUALITY_REDUC = 3;

    function Photo(stage, img, duration, fadeDuration) {
        var me = this;

        me.duration = duration;
        me.progress = 0;

        var i = new Bitmap(img);
        var unscaled = new Container();
        var container = new Container();
        var bg = new Container();
        var timeline;
        var cwidth;
        var cheight;
        var wr;
        var hr;
        var cx;
        var cy;
        var r;

        var iwidth = img.width;
        var iheight = img.height;

        function change() {

            // On peu utiliser l'index de l'image pour adapter le theme
            // me.index

            var pair = (me.index % 2 === 0);
            var p = timeline.position || 0;
            var percent = (p / (duration - fadeDuration * 2));
            me.progress = percent;

/*            var alpha;
            if (percent < 1) {
                alpha = percent * 10;
            } else {
                alpha = 1 - ((percent - 1) * 30);
            }
            alpha = Math.max(alpha, 0);
            alpha = Math.min(alpha, 1);*/


            if (pair) {
                var scaler = r * 1.1 - percent * ((r * 1.10) - r);
            } else { // impair
                var scaler = r + percent * ((r * 1.10) - r);
            }

            //unscaled.alpha = alpha;
            container.scaleX = scaler;
            container.scaleY = scaler;
            //me.ialpha = alpha;
        }


        function updateSize() {
            cwidth = stage.canvas.width;
            cheight = stage.canvas.height;
            wr = cwidth / iwidth;
            hr = cheight / iheight;
            cx = cwidth * 0.5;
            cy = cheight * 0.5;
            r = M.min(wr, hr);
            i.x = -iwidth * 0.5;
            i.y = -iheight * 0.5;
            container.scaleX = r;
            container.scaleY = r;
            container.x = cx;
            container.y = cy;
            
            updateBg();

            //unscaled.alpha = 0;
            //unscaled.shadow = new createjs.Shadow("#000000", 1, 1, 10);
            unscaled.t = 0;
            change();
        }

        /*
        * Génération d'un arrière plan flou
        */
        function updateBg() {
            try {
                const width = (stage.canvas.width / BG_QUALITY_REDUC) | 0;
                const height = (stage.canvas.height / BG_QUALITY_REDUC) | 0;
                bg.cache(0, 0, width, height);
                bg.scaleX = BG_QUALITY_REDUC;
                bg.scaleY = BG_QUALITY_REDUC;
                var ctx = bg.cacheCanvas.getContext("2d");
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, width, height);
                var scale = 1;
                var depth = 20;
                for (var i = 0, w, h; i < depth; i++) {
                    w = width / scale;
                    h = height / scale;
                    scale *= 1.25;
                    ctx.drawImage(bg.cacheCanvas, 0, 0, w, h, 0, 0, width / scale, height / scale);
                }
                for (var i = 0, w, h; i < depth; i++) {
                    w = width / scale;
                    h = height / scale;
                    scale /= 1.25;
                    ctx.drawImage(bg.cacheCanvas, 0, 0, w, h, 0, 0, width  / scale, height / scale);
                }
                ctx.drawImage(bg.cacheCanvas, 0, 0, width , height, -10, -10, width / scale + 20, height / scale + 20);
            } catch (err) {
                $g.error(err);
                me.error = true;//Enable skip & reload for this one
            }
        }

        function clear() {
            var p = unscaled.parent;
            if (p) {
                p.removeChild(unscaled);
            }
            bg.uncache();
        }

        function appear(parent) {
            var p = unscaled.parent;
            if (!p) {
                parent.addChild(unscaled);
                container.setChildIndex(i, container.getNumChildren() - 1);
                updateSize();
            }
        }

        function init() {
            container.addChild(i);
            unscaled.addChild(bg);
            unscaled.addChild(container);
            timeline = Tween.get(unscaled, {paused: true, onChange: change});
            me.timeline = timeline;
            timeline
                    .wait(duration);
        }

        me.show = appear;
        me.hide = clear;
        me.resize = updateSize;
        me.ready = true;
        me.media = img;

        init();
    }

    $g.Photo = Photo;

})(PVPGEngine, createjs, Math);
